import { createAuthToggle } from "@jkast90/kast-common/auth";
import { getDeploymentConfig } from "./deploymentConfig";

/** The API's base URL (ending /api). `hostname` is where the page is served from; tests pass their own. */
export function getWorkspaceApiBaseUrl(
  currentHostname: string = window.location.hostname,
): string {
  // Prioritize user-configured localStorage over auto-detected values
  let url = "";
  const isCurrentHostLocalhost =
    currentHostname === "localhost" || currentHostname === "127.0.0.1";

  // The per-device override is for local development only. A deployed site
  // always uses its configured API: a value saved on a device (the phone that
  // sent every call to this site's own origin, which answers with its home
  // page) would otherwise break it with no way to clear it.
  try {
    const ls = window.localStorage.getItem("dashboard_api_url");
    if (ls) {
      if (isCurrentHostLocalhost) {
        url = ls;
      } else {
        console.log(
          "[settings] Clearing the stored API URL: it only applies on localhost",
        );
        window.localStorage.removeItem("dashboard_api_url");
      }
    }
  } catch {
    /* ignore */
  }

  // If no localStorage value, fall back to deployment config (env vars or auto-detection)
  if (!url || url === "") {
    const deploymentConfig = getDeploymentConfig();
    url = deploymentConfig.apiUrl;
  }

  // Force HTTPS if the page is loaded over HTTPS (except for localhost)
  const isLocalhost = url.includes("localhost") || url.includes("127.0.0.1");
  if (
    window.location.protocol === "https:" &&
    url.startsWith("http://") &&
    !isLocalhost
  ) {
    url = url.replace("http://", "https://");
  }

  // Ensure /api suffix is present
  if (!url.endsWith("/api")) {
    url = url + "/api";
  }

  return url;
}

export function getCognitoDomain(): string {
  return getDeploymentConfig().cognitoDomain;
}

export function getCognitoClientId(): string {
  return getDeploymentConfig().clientId;
}

// Auth settings: kast-common's switch, on unless this device turned it off
// (local development against an API with DISABLE_AUTH).
export const getAuthEnabled = createAuthToggle().get;
